export * from './types'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

export const emendas_parlamentares = {
  state: () => {
    return {
      ano: new Date().getFullYear(),
      emendas: [],
      loading: false
    }
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/emendas_parlamentares/index.js